module.exports = __webpack_public_path__ + "assets/images/02_thumb_146636dd01932e6677ec17e8483a7317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02_thumb.png
// module id = 122
// module chunks = 0